import React, { useEffect, useState } from 'react';
import TabNavBar from './TabNavBar';
import ExamlistTab from './ExamListTab';
import toast from 'react-hot-toast';
import { useQuery } from 'jsonapi-react';
import { useTranslation } from 'react-i18next';
import OpenQuestionBooks from 'app/screens/OpenQuestionBooks';
import Onboarding from 'app/components/Onboarding';
import { useSession } from 'app/hooks/useSession';
import { UserMetrics } from 'app/screens/ExamMetrics/UserMetrics';
import { AdminMetrics } from 'app/screens/ExamMetrics/AdminMetrics';

function ExamsResolution({ path }) {
  const { t } = useTranslation();
  const { session } = useSession();
  const sessionUser = session.user.profileNames[0];
  const [showOnboarding, setShowOnboarding] = useState(false);
  const { data: courses = [], error: errorCourses, isLoading: isLoadingCourses } = useQuery('courses/simple');
  const { data: exams = [], error: errorExams, isLoading: isLoadingExams } = useQuery('question_books?filter[visibility]=exam&filter[except_learning_systems]=true');

  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];
  const isLoading = isLoadingCourses || isLoadingExams;

  useEffect(() => {
    if (errorCourses) {
      toast.error(t('toast.errorGetCourse'));
    }
    if (errorExams) {
      toast.error(t('toast.errorGetExams'));
    }
  }, [errorCourses, errorExams]);

  return (
    <main className="main-content main-content--block">
      <TabNavBar selectedTab={path} />

      {path === '/simulados' && <OpenQuestionBooks courses={courses} />}
      {path === '/avaliacoes' && (
        <ExamlistTab
          courses={courses}
          exams={exams}
          loading={isLoading}
        />
      )}
      {path === '/avaliacoes/meus-resultados' && <>{sessionUser === 'Aluno' ? <UserMetrics courses={courses} /> : <AdminMetrics />}</>}

      <Onboarding
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        path={path}
        profiles={profiles}
        title={path === '/simulados' ? t('onboarding.titleMockQuestionsBook') : t('onboarding.titleExamsResolution')}
      />
    </main>
  );
}

export default ExamsResolution;
